<template>
<b-card no-body class="mb-1">

    <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Ubah Password</span>
        <b-button v-b-toggle.accordion-2 variant="yellow" class="chevron">
            <span class="when-open">
                <b-icon icon="chevron-up" />
            </span>
            <span class="when-closed">
                <b-icon icon="chevron-down" />
            </span>
        </b-button>
    </b-card-header>
    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
      <b-card-body>
          <b-card-text>
  <div class="container">
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <b-form @submit.prevent="updatePassword">
        <b-form-group label="Password saat ini">
          <ValidationProvider v-slot="{ errors }" name="Password saat ini" rules="required">
            <b-form-input
              v-model="old_password"
              placeholder="Masukkan password saat ini"
              type="password"
              required
            ></b-form-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group label="Password baru">
          <ValidationProvider v-slot="{ errors }" name="Password baru" rules="required|min:6|confirmed:confirmation">
            <b-form-input
              v-model="new_password"
              placeholder="Masukkan password baru"
              required
              type="password"
            ></b-form-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group label="Konfirmasi Password baru">
          <ValidationProvider v-slot="{ errors }" name="Konfirmasi password baru" rules="required" vid="confirmation">
            <b-form-input
              v-model="confirm_password"
              placeholder="Masukkan konfirmasi password baru"
              type="password"
              required
            ></b-form-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
        <b-button type="submit" class="btn btn-custom rounded-5 theme-color mr-md-2 mr-auto px-4 mt-3" variant="success">Simpan</b-button>
      </b-form>
    </ValidationObserver>

    <!-- Update password confirmation modal -->
    <b-modal size="sm" v-model="confirmUpdatePasswordModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Apa anda yakin ?</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3 btn-custom cancel" block @click="confirmUpdatePasswordModal = false">Tidak</b-button>
        </div>
        <div class="col">
          <b-button class="mt-3 btn-custom success" block @click="confirmUpdatePassword">Ya</b-button>
        </div>
      </div>
    </b-modal>

    <!-- Success modal for all confirmation  -->
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon :icon="icon" animation="throb" :variant="iconColor" style="width: 120px; height: 120px;"></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </div>
  </b-card-text>
        </b-card-body>
    </b-collapse>
</b-card>
</template>

<script>
import User from '../../api/user'

export default {
  data() {
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
      confirmUpdatePasswordModal: false,
      successModal: false,
      modalText: '',
      icon: '',
      iconColor: '',
      currentUser: null
    }
  },
  created() {
    if (!this.$store.state.auth.user) {
      this.$router.push('/login')
    }
    this.currentUser = this.$store.state.auth.user
  },
  mounted() {
  },
  methods: {
    updatePassword() {
      this.confirmUpdatePasswordModal = true;
    },
    confirmUpdatePassword() {
      const data = {
        id: this.currentUser.info.api_token,
        old_password: this.old_password,
        new_password: this.new_password
      }

      User.updatePassword(data)
      .then(res => {
        if (res.data.meta.code == 200) {
          this.successModal = true
          this.confirmUpdatePasswordModal = false
          this.icon = 'check-circle'
          this.iconColor = 'success'
          this.modalText = 'Password berhasil diubah, silahkan login kembali untuk memastikan'
          this.old_password = ''
          this.new_password = ''
          this.confirm_password = ''
        } else if (res.data.meta.code == 401) {
          this.successModal = true
          this.confirmUpdatePasswordModal = false
          this.modalText = 'Password lama tidak benar!'
          this.icon = 'x-circle-fill'
          this.iconColor = 'danger'
          this.old_password = ''
          this.new_password = ''
          this.confirm_password = ''
        } else {
          console.log(res.data)
        }
      })
      .catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ubah-password.vue